import axios, { AxiosInstance } from 'axios';
import environment from '../environment';

const eswitchClient: AxiosInstance = axios.create({
    baseURL: environment.REACT_APP_E_SWITCH_HOST_URL ? environment.REACT_APP_E_SWITCH_HOST_URL : 'https://api-dev.fordpro.com/eswitch',
    headers: {
        'X-Api-Key': 'electron-api-key-value',
        'Content-Type': 'application/json',
    },
});

export default eswitchClient;
